<template>
    <div id="version-normale">

        <transition name="fade">
            <div id="loading-video" v-if="loading">
                <img src="@/assets/svg/logo.svg" alt="Chargement logo">
                <Loader/>
            </div>
        </transition>

        <transition name="fade">
            <div id="main-video-zone" v-show="!loading">
                <div style="width: 100%;position:relative;">
                    <video id="main-video"
                           src="https://player.vimeo.com/external/290865442.hd.mp4?s=452a2f0d3cbb3c742758878d2e56c3ba591a50c4&profile_id=174" autoplay
                    ></video>
                    <audio id="main-audio" ref="audioFile" muted :src="audio" type="audio/mpeg" loop></audio>
                    <!--<Debug :time="time"/>-->

                    <QuestionnaireAction v-if="time > 13.5 && time < 23" @go="plan(23)"/>

                    <Documentation v-if="time >= 35 && time <= 38" @go="plan(38.25)"/>

                    <Tablet v-if="time >= 108 && time <= 112.5" @go="plan(112.75)"/>

                    <SkipVideo v-if="time > 115 && time < 391"/>

                    <PdfViewer v-if="time > 391 && time < 415"/>

                    <MotionWindow v-if="time > 391 && time < 449"/>

                    <Topics v-if="time >= 475 && time <= 482 || time >= 526 && time <= 532" @go="plan(483)" @go2="plan(532.5)"/>

                    <Objection v-if="time === 449" @go="plan(450)"/>

                    <VisitCard v-if="time >= 549 && time <= 556" @go="plan(556.25)"/>

                    <BackButton v-if="time <= 114"/>

                    <AccelerateButton v-if="time > 80 && time < 105"/>

                    <DragNDropRelaunch v-if="time === 105 "/>

                    <Timeline/>

                    <FullScreenButton/>


                </div>
            </div>
        </transition>

        <Questions v-if="time >= 23 && time <= 24"/>

        <ScreenEnd v-if="time > 557"/>


    </div>
</template>

<script>


    import Documentation from "@/components/Documentation";
    import QuestionnaireAction from "@/components/Questions/QuestionnaireAction";
    import Tablet from "@/components/Tablet";
    import PdfViewer from "@/components/PdfViewer";
    import Objection from "@/components/Objection";
    import Topics from "@/components/Topics";
    import ScreenEnd from "@/components/ScreenEnd";
    import VisitCard from "@/components/VisitCard";
    import FullScreenButton from "@/components/FullScreenButton";
    import Loader from "@/components/Loader";
    import BackButton from "@/components/InteractionVideo/BackButton"
    import AccelerateButton from "@/components/InteractionVideo/AccelerateButton";
    import DragNDropRelaunch from "@/components/InteractionVideo/DragNDropRelaunch";
    import Timeline from "@/components/InteractionVideo/Timeline";
    import SkipVideo from "@/components/InteractionVideo/SkipVideo";
    import Questions from "@/components/Questions";
    import Debug from "../components/Debug";
    import MotionWindow from "../components/MotionWindow";
    import audio from "@/assets/audio/ambient.mp3";


    export default {
        name: "Video",
        components: {
            MotionWindow,
            Debug,
            Questions,
            SkipVideo,
            Timeline,
            DragNDropRelaunch,
            AccelerateButton,
            FullScreenButton,
            VisitCard,
            ScreenEnd,
            Topics,
            Objection,
            PdfViewer,
            Tablet,
            QuestionnaireAction,
            Documentation,
            Loader,
            BackButton
        },
        mounted() {
            this.$refs.audioFile.volume = 0.3;
            this.video = document.querySelector("#main-video")
            this.video.oncanplay = () => {
                this.loading = false
            }
            // this.video.currentTime = 103;
            this.video.ontimeupdate = () => {
                this.time = Math.floor(this.video.currentTime * 4) / 4;
                // GLOBAL ACTION
                if ([22.75, 38, 105, 112.5, 449, 482, 532, 556].indexOf(this.time) + 1) {
                    this.video.pause()
                }
            };
        },
        data() {
            return {
                time: 0,
                loading: true,
                audio
            }
        },
        methods: {
            plan(time) {
                this.video.currentTime = time;
                this.video.play()
            }
        }
    }
</script>

<style lang="scss">

    @import "../assets/css/default";

    #loading-video {
        position: fixed;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-flow: column;
        background-color: #3e6cc6;
        background: linear-gradient(45deg, #3e6cc6, #2237a2);
        background-size: cover;
        background-repeat: no-repeat;
        img {
            width: 220px;
            height: auto;
            margin-bottom: 100px;
        }
    }

    #main-video-zone {
        background-color: black;
        position: fixed;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        #main-video {
            width: 100%;
            pointer-events: none;
        }

    }

</style>